import { useEffect } from 'react';

const Metrics = () => {
    useEffect(() => {


        //const domain = "localhost:8080";

        const protocol = 'https'; //https

        //const domain = "a.usbrowserspeed.com";
        const domain = "testing.usbrowserspeed.com";

        // New /cs script with redirect and puid parametersOrganizationEditForm dallaspid123s
        const scriptCS = document.createElement("script");
        const partnerUID = "testing_b"
        const sitePID = "edbafcb41ae4f79da35810efa94877e6d80bfd3bebf39f390409918dd5c9a3cf"; // "testing-gha-adcmembers-0f35c47831006fbafeb0c46c6a63d4fa6f3c9ace260cfd929b6d63061d14c347"; //dallaspid123s dropswitch
        const redirectUrl = encodeURIComponent('https://testing.usbrowserspeed.com/cs?hem=${HEM_SHA256_LOWERCASE}&up_id=${UP_ID}&md5_hem=${HEM_MD5_LOWERCASE}&puid=${PARTNER_UID}');
        const unEncodedRedirectURL = 'https://testing.usbrowserspeed.com/cs?hem=${HEM_SHA256_LOWERCASE}&up_id=${UP_ID}&md5_hem=${HEM_MD5_LOWERCASE}&puid=${PARTNER_UID}';
        scriptCS.src = `${protocol}://${domain}/cs?pid=${sitePID}&puid=${partnerUID}&r=${redirectUrl}`; //{edirectUrl}`; //`; //&r=${redirectUrl}`; &hem=testtest
        scriptCS.async = false;
        scriptCS.type = 'text/javascript';
        document.body.appendChild(scriptCS);


        var av = document.createElement('script');
        av.src = `https://a.usbrowserspeed.com/metrics.js?pid=${sitePID}`;
        av.type = 'text/javascript';
        //document.body.appendChild(av);










        

        // New /cs script with redirect and puid parametersOrganizationEditForm
        const scriptCS2 = document.createElement("script");
        scriptCS2.src = `${protocol}://${domain}/lds?pid=${sitePID}`; //&r=${redirectUrl}`; &hem=testtest
        scriptCS2.async = true;
        //document.body.appendChild(scriptCS2);


        /*
        // New /cs script with redirect and puid parameters
        const scriptCS = document.createElement("script");
        const sitePID = "dropswitch";
        //const redirectUrl = encodeURIComponent('http://localhost:3200/cs?hem=${HEM_SHA256_LOWERCASE}&up_id=${UP_ID}&puid=testingrt_output');
        scriptCS.src = `https://${domain}/top.js?pid=${sitePID}&puid=testingrt`; //&r=${redirectUrl}`;
        scriptCS.async = true;
        document.body.appendChild(scriptCS);
        */



        // Build the request URL with query parameters:
        // If tuid is present, it signals to the server to return JSON (as per your server logic)
        // Fetch approach
        const fetchUrl = `${protocol}://${domain}/cs?pid=${encodeURIComponent(sitePID)}&puid=testingrt_output`;
        fetch(fetchUrl, {
            method: 'GET',
            credentials: 'include', // Important: include credentials
            headers: {
                'Accept': 'application/json' // Signal that JSON is expected
            }
        })
            .then(response => {
                const contentType = response.headers.get('Content-Type') || '';
                if (!response.ok) throw new Error(`Network response was not ok: ${response.statusText}`);
                if (contentType.includes('application/json')) {
                    return response.json();
                } else {
                    console.log("No JSON returned; possibly no TUID provided or not an approved partner.");
                    return null;
                }
            })
            .then(data => {
                if (data) {
                    console.log("JSON Response from /cs:", data);
                    console.log("TUID:", data.tuid);
                    console.log("HEM:", data.hem);
                    console.log("HEM MD5", data.md5_lower_case)
                    console.log("UP_ID:", data.upID);
                }
            })
            .catch(err => {
                console.error("Error fetching HEM/UP_ID:", err);
            });
    }, []);

    return null;
};

export default Metrics;